// @ts-nocheck
import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import {
  DataArray,
  IDataArray,
  SignalRService,
  SignalREventService,
  ToastrService,
  EquipmentDocuments,
  AuthorizationService,
} from "./../../shared/index";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import {
  Document,
  DeviceDocument,
  DocumentPartMap,
  EquivalentTranslatedLanguage,
} from "./../index";

@Injectable()
export class DocumentService {
  public documentsChange: EventEmitter<Document[]> = new EventEmitter<
    Document[]
  >();
  public historyDocumentsChange: EventEmitter<Document[]> = new EventEmitter<
    Document[]
  >();
  public historyAllDocumentsChange: EventEmitter<Document[]> = new EventEmitter<
    Document[]
  >();
  public deviceDocumentsChange: EventEmitter<DeviceDocument[]> =
    new EventEmitter<DeviceDocument[]>();
  public equipmentDocumentChange: EventEmitter<EquipmentDocuments> =
    new EventEmitter<EquipmentDocuments>();
  public recommendedDocumentsChange: EventEmitter<EquipmentDocuments> =
    new EventEmitter<EquipmentDocuments>();

  public documents: DataArray<Document> = new DataArray<Document>();
  public filteredDocuments: DataArray<Document> = new DataArray<Document>();
  public historyDocuments: DataArray<Document> = new DataArray<Document>();
  public equivalentTranslatedLanguages: DataArray<EquivalentTranslatedLanguage> =
    new DataArray<EquivalentTranslatedLanguage>();

  public startSearch: EventEmitter<string> = new EventEmitter<string>();
  public documentSelectedChange: EventEmitter<Document> =
    new EventEmitter<Document>();
  public clearSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
  public printChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public reloadDocuments: EventEmitter<boolean> = new EventEmitter<boolean>();
  public imageChange: EventEmitter<Blob> = new EventEmitter<Blob>();
  public equivalentTranslatedLanguagesChange: EventEmitter<
    EquivalentTranslatedLanguage[]
  > = new EventEmitter<EquivalentTranslatedLanguage[]>();
  public equivalentTranslatedDocumentAssociated: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public equivalentTranslatedDocumentDeleted: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public documentCreated: EventEmitter<Document> = new EventEmitter<Document>();

  public searchFileName = "";

  public currentPage = 1;
  public totalDocuments = 0;

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _toastrService: ToastrService,
    private _authorizationService: AuthorizationService,
    private _http: HttpClient
  ) {
    this.registerOnServerEvents();
  }

  private onDocuments(info: any): void {
    //@ts-ignore
    this.totalDocuments = info.Data.Total;

    this.documents.init();
    //@ts-ignore
    for (const item of info.Data.Documents) {
      const document: Document = $.extend(new Document(), item);
      this.documents.push(document);
    }

    this.documentsChange.emit(this.documents.Data);
  }

  private onDocumentHistory(info: any): void {
    this.historyDocuments.init();
    //@ts-ignore
    for (const item of info.Data.Documents) {
      const document: Document = $.extend(new Document(), item);
      this.historyDocuments.push(document);
    }

    this.historyDocumentsChange.emit(this.historyDocuments.Data);
  }

  private onDocumentAllHistory(info: any): void {
    this.historyDocuments.init();
    //@ts-ignore
    for (const item of info.Data.Documents) {
      const document: Document = $.extend(new Document(), item);
      this.historyDocuments.push(document);
    }

    this.historyAllDocumentsChange.emit(this.historyDocuments.Data);
  }

  private onDeviceDocuments(info: any): void {
    const documents: DeviceDocument[] = [];
    for (const document of info.Data.Documents) {
      documents.push($.extend(new DeviceDocument(), document));
    }
    this.deviceDocumentsChange.emit(documents);
  }

  private onEquipmentDocuments(info: any): void {
    const equipmentDocuments: EquipmentDocuments = new EquipmentDocuments();
    equipmentDocuments.EquipmentId = info.Data.EquipmentId;
    for (const document of info.Data.Documents) {
      equipmentDocuments.Documents.push($.extend(new Document(), document));
    }
    this.equipmentDocumentChange.emit(equipmentDocuments);
  }

  private onRecommendedDocuments(info: any): void {
    const equipmentDocuments: EquipmentDocuments = new EquipmentDocuments();
    equipmentDocuments.EquipmentId = info.Data.EquipmentId;
    for (const document of info.Data.Documents) {
      equipmentDocuments.Documents.push($.extend(new Document(), document));
    }
    this.recommendedDocumentsChange.emit(equipmentDocuments);
  }

  private onPrintChange(info: any): void {
    this.printChange.emit(true);
  }

  private onEquivalentTranslatedDocumentAssociated(info: any): void {
    this.equivalentTranslatedDocumentAssociated.emit(true);

    //9/6/2023 - added to refresh associated languge list when updating associated languages list
    const equivalentTranslatedLanguages: EquivalentTranslatedLanguage[] = [];
    for (const language of info.Data.Languages) {
      equivalentTranslatedLanguages.push(
        $.extend(new EquivalentTranslatedLanguage(), language)
      );
    }
    this.equivalentTranslatedLanguagesChange.emit(
      equivalentTranslatedLanguages
    );
  }

  private onEquivalentTranslatedDocumentDeleted(info: any): void {
    this.equivalentTranslatedDocumentDeleted.emit(true);
  }

  private onEquivalentTranslatedLanguages(info: any): void {
    const equivalentTranslatedLanguages: EquivalentTranslatedLanguage[] = [];
    for (const language of info.Data.Languages) {
      equivalentTranslatedLanguages.push(
        $.extend(new EquivalentTranslatedLanguage(), language)
      );
    }
    this.equivalentTranslatedLanguagesChange.emit(
      equivalentTranslatedLanguages
    );
  }

  public search(term: string): void {
    this.startSearch.emit(term);
  }

  public getDocuments(page: number): void {
    this.currentPage = page;
    this._signalRService.invoke("GetDocuments", page, this.searchFileName);
  }

  public getHistory(metadataId: number): void {
    this._signalRService.invoke("GetHistory", metadataId);
  }

  public getAllHistory(metadataId: number): void {
    this._signalRService.invoke("GetAllHistory", metadataId);
  }

  public hasMatch(offset: number, filename: string): Promise<boolean> {
    return this._signalRService
      .invoke("GetMatch", offset, filename)
      .then((data: boolean) => {
        return data;
      });
  }

  public getDocumentCountForEquipment(equipmentId: number): Promise<number> {
    return this._signalRService
      .invoke("GetDocumentCountForEquipment", equipmentId)
      .then((data: number) => {
        return data;
      });
  }

  public getDeviceDocuments(deviceId: number): void {
    this._signalRService.invoke("GetDeviceDocuments", deviceId);
  }

  public getEquipmentDocuments(equipmentId: number): void {
    this._signalRService.invoke("GetEquipmentDocuments", equipmentId);
  }

  public addEquivalentTranslated(
    equipmentId: number,
    langPack: string,
    baseLanguage: string
  ): void {
    this._signalRService
      .invoke("AddEquivalentTranslated", equipmentId, langPack, baseLanguage)
      .then(() => {
        this.getEquipmentDocuments(equipmentId);
      });
  }

  public delEquivalentTranslated(
    equipmentId: number,
    baseLanguage: string
  ): void {
    this._signalRService
      .invoke("DeleteEquivalentTranslated", equipmentId, baseLanguage)
      .then(() => {
        this.getEquipmentDocuments(equipmentId);
      });
  }

  public getEquipmentCount(documentId: number): Promise<number> {
    return this._signalRService
      .invoke("GetAssociationCount", documentId)
      .then((result: number) => {
        return result;
      });
  }

  public getRecommended(equipmentId: number): void {
    this._signalRService.invoke("GetRecommended", equipmentId);
  }

  public getEquivalentTranslatedLanguage(equipmentId: number): void {
    this._signalRService.invoke("GetEquivalentTranslatedLanguage", equipmentId);
  }

  public allowDocumentsToPrint(
    selectedDocuments: number[],
    currentUser: string
  ): void {
    this._signalRService.invoke(
      "AllowDocumentsToPrint",
      selectedDocuments,
      currentUser
    );
    //this.printChange.emit(true);
  }

  public restrictDocumentsFromPrint(
    selectedDocuments: number[],
    currentUser: string
  ): void {
    this._signalRService.invoke(
      "RestrictDocumentsFromPrint",
      selectedDocuments,
      currentUser
    );
    //this.printChange.emit(true);
  }

  public applyFilter(
    fileName: string,
    selectedModels: DocumentPartMap[],
    selectedPoweredBys: DocumentPartMap[],
    selectedSuites: DocumentPartMap[],
    selectedLanguages: DocumentPartMap[],
    ableToPrint: boolean,
    notAbleToPrint: boolean
  ): void {
    this.filteredDocuments.init();
    let documents: Document[] = this.documents.Data;
    if (fileName.length > 0) {
      documents = documents.filter(
        (doc) => doc.FileName.toLowerCase().indexOf(fileName.toLowerCase()) > -1
      );
    }

    if (selectedModels.length > 0) {
      documents = documents.filter((doc) => {
        let useDocument = false;
        const docPart: string = doc.FileName.split("-")[0];
        useDocument =
          selectedModels.filter((mdl: DocumentPartMap) => {
            return mdl.Part == docPart;
          }).length > 0;
        return useDocument;
      });
    }

    if (selectedPoweredBys.length > 0) {
      documents = documents.filter((doc) => {
        let useDocument = false;
        const docPart: string = doc.FileName.split("-")[1];
        useDocument =
          selectedPoweredBys.filter((mdl: DocumentPartMap) => {
            return mdl.Part == docPart;
          }).length > 0;
        return useDocument;
      });
    }

    if (selectedSuites.length > 0) {
      documents = documents.filter((doc) => {
        let useDocument = false;
        const docPart: string = doc.FileName.split("-")[2];
        useDocument =
          selectedSuites.filter((mdl: DocumentPartMap) => {
            return mdl.Part == docPart;
          }).length > 0;
        return useDocument;
      });
    }
    if (selectedLanguages.length > 0) {
      documents = documents.filter((doc) => {
        let useDocument = false;
        if (doc.FileName.split(".")[0].split("-").length >= 4) {
          const docPart: string = doc.FileName.split(".")[0].split("-")[4];
          useDocument =
            selectedLanguages.filter((mdl: DocumentPartMap) => {
              return mdl.Part == docPart;
            }).length > 0;
        }
        return useDocument;
      });
    }
    if (ableToPrint == true && notAbleToPrint == false) {
      documents = documents.filter((doc) => doc.AllowPrinting == true);
    }
    if (ableToPrint == false && notAbleToPrint == true) {
      documents = documents.filter((doc) => doc.AllowPrinting == false);
    }
    // force no documents to return
    if (ableToPrint == false && notAbleToPrint == false) {
      documents = documents.filter((doc) => doc.Id == -1);
    }

    this.documentsChange.emit(documents);
  }

  public selectDocument(document: Document): void {
    this.documentSelectedChange.emit(document);
  }

  public clearAll(): void {
    this.clearSelected.emit(true);
  }

  public getAllDocuments(): void {
    this._http
      .get("/api/Manuals/GetAllDocuments?search=")
      .pipe(
        map((info) => {
          this.totalDocuments = info.Data.Total;
          this.documents.init();

          for (let item of info.Data.Documents) {
            let document: Document = $.extend(new Document(), item);
            this.documents.push(document);
          }

          this.documentsChange.emit(this.documents.Data);
        })
      )
      .subscribe();
  }

  public reloadAllDocuments(): void {
    this._http
      .get("/api/Manuals/GetAllDocuments?search=")
      .pipe(
        map((info) => {
          this.totalDocuments = info.Data.Total;
          this.documents.init();

          for (let item of info.Data.Documents) {
            let document: Document = $.extend(new Document(), item);
            this.documents.push(document);
          }

          this.reloadDocuments.emit(true);
        })
      )
      .subscribe();
  }

  //TOOD: NEED TO INVESTIGATE THIS - refer to changes made in 97ebf86 and 1ee3855

  public getCoverImage(metadataid: number): void {
    const headers = new HttpHeaders({ "Content-Type": "image/png" });

    this._http
      .get("/api/Manuals/CoverPage?metadataId=" + metadataid.toString(), {
        headers: headers,
        responseType: "blob" as "json",
      })
      .pipe(
        map((data: Blob) => {
          this.imageChange.emit(data);
        })
      )
      .subscribe();
  }

  public createDocument(
    fileName: string,
    fmiMetadataId: number,
    productName: string,
    version: string,
    allowPrinting: boolean,
    currentUser: string
  ): void {
    this._signalRService.invoke(
      "CreateDocument",
      fileName,
      fmiMetadataId,
      productName,
      version,
      allowPrinting,
      currentUser
    );
  }

  private onCreateDocument(data: any): void {
    const document = $.extend(new Document(), data);
    this.documentCreated.emit(document);
    //this.getUsers(this.currentPage);
  }

  // Error handling
  private handleError(error: any): Observable<never> {
    console.error("Error downloading PDF:", error);
    return throwError("Failed to download PDF. Please try again later.");
  }

  public downloadPDF(documentId: number): Observable<HttpResponse<Blob>> {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      `Bearer ${this._authorizationService.getAuthorization()}`
    );
    const url = `${window.document.location.origin}/api/Manuals/Download?documentId=${documentId}`;
    return this._http
      .get(url, {
        headers: headers,
        responseType: "blob",
        observe: "response",
      })
      .pipe(catchError(this.handleError));
  }

  private registerOnServerEvents() {
    this._signalREventService.register(
      "DocumentService",
      "documents",
      (info: any) => this.onDocuments(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "documentHistory",
      (info: any) => this.onDocumentHistory(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "documentAllHistory",
      (info: any) => this.onDocumentAllHistory(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "deviceDocuments",
      (info: any) => this.onDeviceDocuments(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "associatedEquipmentDocuments",
      (info: any) => this.onEquipmentDocuments(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "recommendedDocuments",
      (info: any) => this.onRecommendedDocuments(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "documentCreate",
      (info: any) => this.onCreateDocument(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "printChange",
      (info: any) => this.onPrintChange(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "equivalentTranslatedDocumentAssociatedCreated",
      (info: any) => this.onEquivalentTranslatedDocumentAssociated(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "equivalentTranslatedDocumentAssociatedDeleted",
      (info: any) => this.onEquivalentTranslatedDocumentDeleted(info)
    );
    this._signalREventService.register(
      "DocumentService",
      "equivalentTranslatedLanguages",
      (info: any) => this.onEquivalentTranslatedLanguages(info)
    );
  }

  private deregisterOnServerEvents(): void {
    this._signalREventService.deregister("DocumentService");
  }
}
